import { authFetch } from "@/api/authFetch.ts"
import { API_BASE } from "@/config.ts"

export const deleteReport = async (id: number) => {
  await authFetch(`${API_BASE}/reports/${id}`, {
    method: "DELETE",
  })
}
